"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'route.user.list': 'Użytkownicy',
    'route.user.create': 'Dodaj użytkownika',
    'route.user.edit': 'Edytuj użytkownika',
};
